<script>
import Vuex from 'vuex';
import '#/store/module/popupAction.vuex';
import ModulePopupAction from '#/store/module/popupAction.vuex';

export default {
  store() {
    return new Vuex.Store(ModulePopupAction);
  },

  beforeDestroy() {
    if (this.timeoutControl) {
      this.cancelMastHeadTimeout();
    }
  },

  data() {
    return {
      timeoutControl: null,
      timeoutControlTime: 2000,
      modal: this.$attrs['in-modal'],
    };
  },

  computed: Object.assign(
    {
      //
    },
    Vuex.mapGetters([
      'getMastHeadVisibleStatus',
      'getMastHeadCurrentType',
      'isPlaying',
      'getActionPanelOpenStatus',
    ])
  ),

  watch: {
    isPlaying(status) {
      if (status) {
        this.changedMastheadType('transparent');
        this.cancelMastHeadTimeout();
        this.createMastHeadTimeout();
      } else {
        this.changedMastheadType('light');
        this.cancelMastHeadTimeout();
        this.showMastHead();
      }
    },
  },

  methods: Object.assign(
    {
      createMastHeadTimeout() {
        this.timeoutControl = setTimeout(() => {
          this.hideMastHead();
        }, this.timeoutControlTime);
      },

      cancelMastHeadTimeout() {
        clearTimeout(this.timeoutControl);
      },

      onProducedMove(e) {
        this.cancelMastHeadTimeout();
        this.showMastHead();

        // if it's not the video, should preserve the controls
        if (/VIDEO/.test(e.target.tagName) && this.isPlaying) {
          this.changedMastheadType('transparent');
          this.createMastHeadTimeout();
        }
      },

      onProducedLeave() {
        this.cancelMastHeadTimeout();

        if (this.isPlaying) {
          this.hideMastHead();
        }
      },
    },
    Vuex.mapMutations([
      'toggleActionPanel',
      'showMastHead',
      'hideMastHead',
      'changedMastheadType',
    ])
  ),
};
</script>
